<div class="container home-container">
  <mat-card style="margin-top: 50px">
    <ng-container *ngIf="!userState || (!userState?.isInteractiveUser && !userState?.isReportExportUser && !userState.isEmbeddedUser)">
      <div class="row">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
          <h1 style="margin-left: -4px" class="mt-5">Public Insight Subscription Services</h1>
        </div>
        <div class="col-sm-1"></div>
      </div>
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-sm-8">
          Please login to access your subscriber services
        </div>
        <div class="col-sm-3"></div>
      </div>
    </ng-container>
    <div class="row" style="margin-top: 50px"></div>
    <div class="row" *ngIf="hasMultiple">
      <div class="col-md-1"></div>
      <div class="col-md-4">
        <mat-form-field style="width: 450px; margin-left: -15px;" class="home-select">
          <mat-select name="selectedSection" [(ngModel)]="selectedSection" class="home-select">
            <mat-option [value]="0">Interactives</mat-option>
            <mat-option [value]="1">Reporting Services</mat-option>
            <mat-option [value]="2">Widgets</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <self-service-analytics-home [showHeader]="!hasMultiple" *ngIf="(userState?.isInteractiveUser && !hasMultiple) || (hasMultiple && selectedSection === 0)"></self-service-analytics-home>
    <powerbi-report-home [showHeader]="!hasMultiple" *ngIf="(userState?.isReportExportUser && !hasMultiple) || (hasMultiple && selectedSection === 1)"></powerbi-report-home>
    <powerbi-widget-home [showHeader]="!hasMultiple" *ngIf="(userState?.isEmbeddedUser && !hasMultiple) || (hasMultiple && selectedSection === 2)"></powerbi-widget-home>
    <div class="row">
      <div class="col-sm-1"></div>
      <div class="col-sm-10">
        New to <b>Public Insight</b>?
        <b><a [routerLink]="['/register']">Click here</a></b> to register.
      </div>
      <div class="col-sm-1"></div>
    </div>
    <div class="row">
      <div class="col-sm-1"></div>
      <div class="col-sm-10">
        Registration is required to subscribe or use Public Insight services.
      </div>
      <div class="col-sm-1"></div>
    </div>
    <div class="row" style="height: 50px">
      <br /><br />
    </div>
  </mat-card>
</div>
